import React, { useEffect, useState, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { fetchProfessionalTournaments } from "../../action/professionalTournamentsAction";
import { useDispatch, useSelector } from "react-redux";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import $ from "jquery";
import moment from "moment";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
  IconButton,
  Skeleton,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { fetchBannersData } from "../../action/bannersActions";
import { defineLocale } from "moment/moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TournamentVideoDeleteModal from "../../component/Modals/DeleteModal";
// import ViewTournament from "../../../component/Modals/ViewTournament";
import ViewTournament from "../../component/Modals/ViewTournament";
import LisitingSkeleton from "../common/LisitingSkeleton";
import ClearIcon from "@mui/icons-material/Clear";
import CustomDeleteModal from "../../component/Modals/CustomDeleteModal";
import BannerSkeleton from "../../component/skeleton/BannerSkeleton";
import DeleteIconMui from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { fetchYoutubeLinksData } from "../../action/youtubeLinksActions";

const goalsColumn = [
  { id: "banner_select", label: "banner_select", width: "5%" },
  { id: "Link", label: "LINK", width: "20%" },
  { id: "category", label: "CATEGORY", width: "55%" },
  { id: "banner_actions", label: "ACTIONS", width: "20%" },
];

// const columns = [
//   { field: "banner_img", headerName: "BANNER", width: 90 },
//   { field: "category", headerName: "CATEGORY", width: 90 },
//   { field: "actions", headerName: "ACTIONS", width: 90 },
// ];

const Banners = () => {
  const navigate = useNavigate();
  const youtubeLinksData = useSelector((state) => state.youtubeLinks);
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [viewBanner, setViewBanner] = useState(false);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);

  // current selected for delete modal
  const currentRef = useRef(null);
  // current call back selected for delete modal
  const currentCallback = useRef(null);
  // current custom text
  // const [currentText, setCurrentText] = useState(null);
  const currentTextRef = useRef(null);

  useEffect(() => {
    dispatch(fetchYoutubeLinksData(token, 1));
  }, [dispatch, token]);

  useEffect(() => {
    if (youtubeLinksData?.data?.success) {
      if (youtubeLinksData?.data?.data?.rows.length > 0) {
        // setGoals("NO Data");
        setGoals(youtubeLinksData.data?.data?.rows);
        setCurrentPage(youtubeLinksData?.data?.data?.currentPage);
        setTotalPages(Math.ceil(youtubeLinksData?.data?.data.count / 10));
        // setGoals([]);
      } else {
        setGoals("NO Data");
      }
    } else if (!youtubeLinksData?.data?.success) {
      setGoals(youtubeLinksData?.data?.message);
    }
  }, [youtubeLinksData]);

  const handleChangePage = (event, newPage) => {
    dispatch(fetchBannersData(token, newPage));
  };

  const handleDeleteBanner = async (ref) => {

    if (ref.current && ref.current?.id) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/deleteLink/${ref.current.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          dispatch(fetchYoutubeLinksData(token, currentPage));
          toast.success("link deleted successfully");
        }
      } catch (error) {
        toast.error("Please try again..");
      } finally {
        setOpenDelete(false);
      }
    } else {
      toast.error("error!!");
    }
  };

  async function handleMultipleDelete(ref) {
    try {
      const ids = Array.from(ref.current.entries()).map((ele) => ele[0]);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleLinks`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        dispatch(fetchYoutubeLinksData(token, currentPage));
        toast.success("Selected Banners deleted successfully");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      // setOpenMulitDelete(false);
      setOpenDelete(false);
    }
  }

  return (
    <>
      <ToastContainer />
      <Box className="page_title custom-header">
        <Typography variant="h1" component="h1">
          Youtube Links
        </Typography>

        {/* <DeleteOutlineIcon className="delete-icon" /> */}
        <Box sx={{ display: "flex", gap: "10px" }}>
          <IconButton
            onClick={() => {
              if (
                Array.from(multipleSelect.current.entries()).map(
                  (ele) => ele[0]
                ).length == 0
              ) {
                toast.error("select the banner");
                return;
              }
              currentRef.current = multipleSelect.current;
              // multipleSelect.current.clear();
              currentCallback.current = handleMultipleDelete;
              currentTextRef.current =
                "Are You Sure . You want to delete these Selected Links.";

              setOpenDelete(true);
              // setCurrentText(
              //   "Are You Sure . You want to delete these Selected Banners."
              // );
            }}
          >
            <DeleteIconMui />
          </IconButton>
          <Button
            className="create-custom"
            onClick={() =>
              navigate("/admin/dashboard/youtube-links/add-youtube-links")
            }
          >
            <AddIcon className="delete-icon" /> Create
          </Button>
        </Box>
      </Box>
      <Box className="page_inner">
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "700px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id != "banner_select" ? (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        {column.label}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(goals) && goals.length > 0 ? (
                  goals.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Box className="td-wrapper">
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text"
                            >
                              {value?.link}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.linkCategory?.name}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              onClick={() => {
                                deleteSelected.current = value;
                                // setCurrentSelect(value);
                                currentRef.current = value;
                                // setCurrentCallback(handleDeleteBanner);
                                currentCallback.current = handleDeleteBanner;
                                currentTextRef.current =
                                  "Are You Sure . You want to delete the Link.";
                                setOpenDelete(true);
                              }}
                              // className="visible_user"
                              sx={{ paddingRight: "0px", minWidth: "0px" }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>

                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                // deleteSelected.current = value;
                                // setViewBanner(true);
                                navigate(
                                  `/admin/dashboard/youtube-links/edit-youtube-links/${value.id}`
                                );
                              }}
                            >
                              <EditIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : goals !== "NO Data" ? (
                  Array.from({ length: 10 }).map((e, i) => <BannerSkeleton key={i} />)
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {goals}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* view image modal  */}
      <Modal
        open={viewBanner}
        onClose={() => setViewBanner(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="viewBannerModal">
          <Box className="bannerModalImageOuter">
            {deleteSelected.current && (
              <img src={deleteSelected.current.banner_img} alt="banner image" />
            )}
          </Box>
          <IconButton
            className="clear-button"
            onClick={() => setViewBanner(false)}
          >
            <ClearIcon />
          </IconButton>
        </Box>
      </Modal>

      {/* custom delete modal */}
      <CustomDeleteModal
        open={openDelete}
        setOpen={setOpenDelete}
        selected={currentRef}
        deleteCallBack={currentCallback}
        customText={currentTextRef.current}
      />
    </>
  );
};

export default Banners;
